import { fetchApi } from '@/services/api-client';

import type { InquiryNote } from '../inquiry-notes/inquiry-notes';

export const TOUR_REQUESTS_PATH = '/tour-requests';

/** `replied` is "we have written to them, waiting on the family". */
export type TourRequestStatus = 'new' | 'replied' | 'confirmed' | 'completed' | 'cancelled';

/** Staff who can be given a tour to host. */
export type TourHost = {
  id: string;
  displayName: string;
  role: string;
};

export type UpdateTourStatusInput = {
  status: TourRequestStatus;
  /** ISO instant. Required to confirm, unless the request already carries one. */
  scheduledAt?: string;
  assignedUserId?: string;
};

export type TourRequest = {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  children: { name: string; dateOfBirth: string }[];
  message: string | null;
  status: TourRequestStatus;
  scheduledAt: string | null;
  assignedUserId: string | null;
  assignedUserName: string | null;
  createdAt: string;
  updatedAt: string;
};

export type TourRequestDetail = TourRequest & {
  notes: InquiryNote[];
};

export const tourRequestsApi = {
  getAll: (status?: TourRequestStatus) => {
    const params = status ? `?status=${status}` : '';
    return fetchApi<TourRequest[]>(`${TOUR_REQUESTS_PATH}${params}`);
  },
  getById: (id: string) => fetchApi<TourRequestDetail>(`${TOUR_REQUESTS_PATH}/${id}`),
  updateStatus: (id: string, input: UpdateTourStatusInput) =>
    fetchApi<TourRequest>(`${TOUR_REQUESTS_PATH}/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify(input),
    }),
  hosts: () => fetchApi<TourHost[]>(`${TOUR_REQUESTS_PATH}/hosts`),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${TOUR_REQUESTS_PATH}/${id}`, { method: 'DELETE' }),
};
